module.exports = __webpack_public_path__ + "static/img/bg.ff674ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/six/bg.png
// module id = yd8/
// module chunks = 1